export default __webpack_public_path__ + "static/media/1-min.f4c3376f.jpg";